import * as z from "zod";

export const pushV2Configuration = {
  name: "pushV2Configuration" as const,
  input: z.object({
    teamId: z.string().min(1),
    productId: z.string().min(1),
    sections: z.array(z.string()).optional(),
  }),
  output: z.object({ ok: z.boolean(), error: z.string().optional() }),
};

export type PushV2ConfigurationInput = z.infer<
  typeof pushV2Configuration.input
>;
export type PushV2ConfigurationOutput = z.infer<
  typeof pushV2Configuration.output
>;
